// Import the pure types module (not the package barrel) so this stays
// importable from Vitest without dragging the chat runtime in.
import { isAskUserQuestionStagedAction } from './ask-user-question/types'

/**
 * Whether a question's own chat thread already renders it, which is what keeps
 * it out of the actions panel. Mirrors `feedback-hosting`, except the host is a
 * conversation rather than another row, so there is nothing to pair against.
 *
 * A question is not a draft: nothing is staged to execute, there is nothing to
 * undo, and its value dies with the run it paused. Listing one beside real
 * drafts is what leaves 13-day-old questions nobody can answer any more — the
 * title is capped at 80 characters, so the row cannot carry enough of the
 * conversation to be answerable in place.
 *
 * A background run has no thread, so the panel is its only surface and its
 * questions stay. `askedFrom` is stamped at creation; rows written before it
 * existed carry none and keep the old behaviour.
 */
export function isQuestionHostedByItsChat(action: {
  toolSet?: string
  toolName?: string
  metadata?: Record<string, string> | null
}): boolean {
  return isAskUserQuestionStagedAction(action) && action.metadata?.askedFrom === 'chat'
}
